export interface Snippet {
  body: string;
  displayAuthorsBox: boolean;
  image: {
    url: string;
  } | null;
  link: string;
  linkTitle?: string;
  title: string;
  tagIds: string[];
}

export interface SnippetList {
  results: Snippet[];
  totalResults: number;
}

export enum SnippetType {
  BOILER_PLATE = 'boilerplate',
  CUSTOM_PAGE = 'custom_page',
  QUICK_LINK = 'quick_link',
}

export interface SnippetParams {
  type: SnippetType;
  tags?: string[][];
}

export enum SnippetSortOption {
  publishDate_desc = 'publishDate_desc',
  snippetDate = 'snippetDate',
  snippetDate_desc = 'snippetDate_desc',
}
